import { useEffect, useRef, useState, useCallback } from "react";

/**
 *  Hook to run a counter with an interval and end count.
 *
 */
export const useCounter = (minCount, maxCount, interval, onDone) => {
  const [count, setCount] = useState(minCount);
  const intervalId = useRef(null);

  /** Effect to watch for end of count.
   */
  useEffect(() => {
    // Clear interval when done counting.
    if (count >= maxCount && intervalId.current !== null) {
      clearInterval(intervalId.current);
      if (onDone) {
        // Call the done handler.
        onDone();
      }
    }
  }, [count, maxCount, interval, onDone]);

  /** Effect to clean up the interval on unmount.
   */
  useEffect(() => {
    // console.log(`counting ${minCount} to ${maxCount}`);

    return () => {
      if (intervalId.current !== null) {
        clearInterval(intervalId.current);
      }
    };
  }, []);

  /** Start the counter.
   */
  const start = useCallback(() => {
    intervalId.current = setInterval(() => {
      setCount((c) => c + 1);
    }, interval);
  }, [interval]);

  return {
    startCounter: start,
    count: count,
  };
};
